module.exports = __webpack_public_path__ + "img/prj04.0dca5c0c.png";